"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import parse from "html-react-parser";
import { cn } from "@/utils/helpers";
import { FileText, Undo2, ChevronDown } from "lucide-react";
interface ProductAccordionProps {
  product: {
    description?: string;
    return_policy?: string;
    metadata?: {
      return_policy?: string;
    };
    vendor_details?: {
      return_policy?: string;
      metadata?: {
        return_policy?: string;
      };
    };
    [key: string]: unknown;
  };
}
interface AccordionItem {
  id: string;
  title: string;
  icon: React.ReactNode;
  content: React.ReactNode;
}
const ProductAccordion: React.FC<ProductAccordionProps> = t0 => {
  const $ = _c(22);
  const {
    product
  } = t0;
  const [openSectionId, setOpenSectionId] = useState(null);
  if (!product) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = id => {
      setOpenSectionId(prev => prev === id ? null : id);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleSection = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== product) {
    const formattedDescription = product?.description ? product.description.replace(/<(p|div)([^>]*)>(?:\s|&nbsp;)*<\/\1>/gi, "<$1$2><br/></$1>").replace(/&nbsp;/g, " ") : "";
    const returnPolicyText = product?.return_policy || product?.metadata?.return_policy || product?.vendor_details?.metadata?.return_policy || product?.vendor_details?.return_policy || "";
    const formattedReturnPolicy = returnPolicyText ? returnPolicyText.replace(/<(p|div)([^>]*)>(?:\s|&nbsp;)*<\/\1>/gi, "<$1$2><br/></$1>").replace(/&nbsp;/g, " ") : "";
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <FileText className="w-5 h-5" />;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    const t8 = formattedDescription ? <div className="rich-text-content break-words whitespace-normal text-stone-500 font-light leading-relaxed text-sm">{parse(formattedDescription)}</div> : <p className="text-stone-500 font-light text-sm leading-relaxed">No description available for this product.</p>;
    if ($[8] !== t8) {
      t6 = {
        id: "description",
        title: "Description",
        icon: t7,
        content: t8
      };
      $[8] = t8;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t2 = "return-policy";
    t3 = "Return Policy";
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Undo2 className="w-5 h-5" />;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t5 = formattedReturnPolicy ? <div className="rich-text-content break-words whitespace-normal text-stone-500 font-light leading-relaxed text-sm">{parse(formattedReturnPolicy)}</div> : <p className="text-stone-500 font-light text-sm leading-relaxed">No return policy available for this product.</p>;
    $[1] = product;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t7 = {
      id: t2,
      title: t3,
      icon: t4,
      content: t5
    };
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = [t6, t7];
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const accordionItems = t8;
  let t9;
  if ($[19] !== accordionItems || $[20] !== openSectionId) {
    t9 = <div className="w-full font-outfit mt-8 border-t border-stone-200/60 select-none">{accordionItems.map(item => {
        const isOpen = openSectionId === item.id;
        return <details key={item.id} open={isOpen} className="border-b border-stone-200/60 w-full"><summary onClick={e => {
            e.preventDefault();
            toggleSection(item.id);
          }} className="w-full py-4 flex items-center justify-between text-stone-500 hover:text-stone-700 transition-colors focus:outline-none bg-transparent border-none cursor-pointer list-none [&::-webkit-details-marker]:hidden"><div className="flex items-center gap-3"><span className="text-v2-primary opacity-70 w-6 flex-shrink-0 inline-flex items-center justify-start">{item.icon}</span><span className="font-normal text-sm uppercase tracking-wider text-stone-500">{item.title}</span></div><ChevronDown className={cn("text-stone-500 w-5 h-5 transition-transform duration-300 ease-out", isOpen && "rotate-180")} /></summary><div className={cn("grid transition-all duration-300 ease-in-out overflow-hidden", isOpen ? "grid-rows-[1fr] opacity-100 pb-5" : "grid-rows-[0fr] opacity-0")}><div className="overflow-hidden pl-9 pr-1">{item.content}</div></div></details>;
      })}</div>;
    $[19] = accordionItems;
    $[20] = openSectionId;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default ProductAccordion;